function is(value, type)
{
  return Object.prototype.toString.apply(value) === `[object ${type}]`;
}

function getResponse(request, $default = null, transform = (body) => body){
  if (!!request)
  {
    if (!!request.body)
    {
      let body = request.body;
      if (body.code === 200)
      {
        return transform(body);
      }
    }
  }

  return $default;
}

function array_set_value(array, values)
{
  array.splice.apply(array, [0, array.length, ...values]);
}

function string_reverse(str)
{
  return str.split('').reverse().join('');
}

function number_format(number, decimals = 2, config = {})
{
  let decimalSeparator = config.decimalSeparator;
  (decimalSeparator===undefined)&&(decimalSeparator = '.');

  let millionSeparator = config.millionSeparator;
  (millionSeparator===undefined)&&(millionSeparator = ',');

  let round = config.round;
  (round===undefined)&&(round = false);

  let integerPart = Math.trunc(number);
  integerPart = String(integerPart);

  integerPart = string_reverse(integerPart);
  integerPart = integerPart.match(/.{1,3}/g);
  integerPart = integerPart.join(millionSeparator);
  integerPart = string_reverse(integerPart);

  let decimalPart = number % 1;
  let mult = 10 ** decimals;

  decimalPart = decimalPart * mult;
  decimalPart = round ? Math.round(decimalPart): Math.trunc(decimalPart);
  decimalPart = decimalPart / mult;

  decimalPart = decimalPart.toFixed(decimals);
  decimalPart = decimalPart.split('.');

  let decimal = '';
  if (decimalPart.length === 2)
  {
    decimal = `${decimalSeparator}${decimalPart[1]}`
  }

  return `${integerPart}${decimal}`;
}

function toBracketNotation(obj, output, parentKey = undefined)
{
  (output===undefined)&&(output={});
  if (is(obj, 'Object') || is(obj, 'Array') )
  {
    let _obj = (!!obj.toJSON)? obj.toJSON(): obj;

    let keys = Object.keys(_obj);
    for(let key of keys)
    {
      let value = _obj[key];

      if (!!parentKey)
      {
        key = `${parentKey}[${key}]`;
      }

      if (!is(value, 'Object') && !is(value, 'Array')){
        output[key] = value;
        continue;
      }

      toBracketNotation(value, output, key);
    }
  }

  return output;
}

window['toBracketNotation'] = toBracketNotation;

function toFormData(obj, formData)
{
  (formData===undefined)&&(formData=new FormData());
  if (!!obj)
  {

  }

  return formData;
}

function verifyPermissions(permissions, controller, action)
{
  let modules = permissions.filter(p => p.name.toLowerCase() === controller.toLowerCase());
  if(modules.length > 0){
    return modules[0].permisos.filter(p => p.toLowerCase() === action.toLowerCase()).length > 0;
  }
  return false;
}

module.exports = {
  getResponse,
  array_set_value,
  number_format,
  string_reverse,
  toBracketNotation,
  verifyPermissions
}
